import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from 'src/app/global';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { tap } from 'rxjs/operators';



@Injectable()
export class WebPushNotificationService {
    public url: string;
    public url_app: string;
    public token;
    public tokenPush;
    public identity
    public Pcompany;
    public Poperacion;


  constructor(private _http: HttpClient,
    private AfMessagin: AngularFireMessaging,
    ) {
    this.url= GLOBAL.url;
    this.identity = this.getIdentity();
  }

  async tokenWebPushNotify(){
    await this.AfMessagin.requestToken.subscribe(
    token =>{
      // console.log('token autenticacion', token)
       this.tokenPush = token
     },err =>{
       console.log(err)
     }
   )
  }

  getTokenWebPush(){
    return this.tokenPush
  }

  getMessages() {
    return this.AfMessagin.messages;
  }
 
  deleteToken() {
    if (this.token) {
      this.AfMessagin.deleteToken(this.token);
      this.token = null;
    }
  }

//   public sendSubscriptionToTheServer(subscription: PushSubscription) {
//     return this.http.post(this.url+'reserva/', subscription);
//   }

// sendSubscriptionToTheServer(subscription: PushSubscription){
//     // console.log(register);
//     let paramas = JSON.stringify(subscription);
//         let headers = new HttpHeaders({'content-Type':'application/json','Authorization': this.getToken()});
//         return this._http.post(this.url+'subscripcion/'+this.identity._id, paramas, {headers:headers})                    
//   }

  // sendSubscriptionOperacion(subscription: PushSubscription){
  //   // console.log(register);
  //   let paramas = JSON.stringify(subscription);
  //       let headers = new HttpHeaders({'content-Type':'application/json','Authorization': this.getToken()});
  //       return this._http.post(this.url+'subscripcion/'+this.Poperacion._id, paramas, {headers:headers})                    
  // }

  // notificarme(){
  //   // console.log(register);
  //       let headers = new HttpHeaders({'content-Type':'application/json','Authorization': this.getToken()});
  //       return this._http.post(this.url+'enviar-notificacion/', null, {headers:headers})
  // }


  // notificarServicio(register){
  //   // console.log(register);
  //   let paramas = JSON.stringify(register);
  //       let headers = new HttpHeaders({'content-Type':'application/json','Authorization': this.getToken()});
  //       return this._http.post(this.url+'enviar-notificacion-servicio/', paramas, {headers:headers})
                   
  // }

  aceptarPedido(register){
    // console.log(register);
    let paramas = JSON.stringify(register);
        let headers = new HttpHeaders({'content-Type':'application/json','Authorization': this.getToken()});
        return this._http.post(this.url+'enviar-notificacion-aceptarPedido/', paramas, {headers:headers})
                   
  }


  // aceptarPedidoCiberi(register){
  //   // console.log(register);
  //   let paramas = JSON.stringify(register);
  //       let headers = new HttpHeaders({'content-Type':'application/json','Authorization': this.getToken()});
  //       return this._http.post(this.url_app+'notificar-usuario/', paramas, {headers:headers})
                   
  // }

  // notificarDespacho(register){
  //   // console.log(register);
  //   let paramas = JSON.stringify(register);
  //       let headers = new HttpHeaders({'content-Type':'application/json','Authorization': this.getToken()});
  //       return this._http.post(this.url+'enviar-notificacion-despachoPedido/', paramas, {headers:headers})
                   
  // }


  notificarCancelacion(register){
    // console.log(register);
    let paramas = JSON.stringify(register);
        let headers = new HttpHeaders({'content-Type':'application/json','Authorization': this.getToken()});
        return this._http.post(this.url+'enviar-notificacion-cancelarPedido/', paramas, {headers:headers})
  }

  // notificarAceptarn(register){
  //   // console.log(register);
  //   let paramas = JSON.stringify(register);
  //       let headers = new HttpHeaders({'content-Type':'application/json','Authorization': this.getToken()});
  //       return this._http.post(this.url+'cotizacion-email-notificar-aceptar/', paramas, {headers:headers})
  // }


  getToken(){
    let token = localStorage.getItem('token');
    if(token != "undefined"){
        this.token = token;
    }else{
       this.token = null;
    }
    return this.token;
  }

  getIdentity(){
    let identity = JSON.parse(localStorage.getItem('identity'));
    if(identity != "undefined"){
        this.identity = identity;
    }else{
        this.identity = null;
    }
    return this.identity;
}





}






